"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpSmallIcon = HelpSmallIcon;

var _react = _interopRequireDefault(require("react"));

function HelpSmallIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 1.333A6.674 6.674 0 0 0 1.333 8 6.674 6.674 0 0 0 8 14.667 6.674 6.674 0 0 0 14.667 8 6.674 6.674 0 0 0 8 1.333ZM8.667 12H7.333v-1.333h1.334V12Zm.65-3.257c-.13.106-.256.206-.356.306-.272.272-.294.518-.294.529v.089H7.333v-.112c0-.078.02-.784.684-1.449.13-.13.292-.262.461-.4.49-.396.81-.685.81-1.084a1.29 1.29 0 0 0-2.577 0H5.377A2.626 2.626 0 0 1 8 4a2.626 2.626 0 0 1 2.623 2.623c0 1.064-.786 1.7-1.306 2.12Z",
    fill: "currentColor"
  }));
}